import styled from 'styled-components';

const FormHeading = styled.h2`
    margin: 0 0 5px 0;
    height: 24px;
    color: ${props => props.theme.forms.header};
    font-family: Lato;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;

    a {
        padding-left:15px;
        font-size: 20px;
    }
`;

export default FormHeading;



// WEBPACK FOOTER //
// ./src/components/atoms/form/FormHeading.js